import {
  AfterViewChecked,
  Component,
  Input,
  SimpleChanges,
} from "@angular/core";

import { ApexOptions } from "ng-apexcharts";
import { themeColor } from "src/utils/theme-color";

@Component({
  selector: "app-circle-progress-chart",
  templateUrl: "./circle-progress-chart.component.html",
  styleUrl: "./circle-progress-chart.component.scss",
  standalone: false,
})
export class CircleProgressChartComponent implements AfterViewChecked {
  @Input() set color(value: string) {
    switch (value) {
      case "primary": {
        this.barColor = themeColor("--brand-ink", "#0c557d");
        break;
      }
      case "warning": {
        this.barColor = "#bb820f";
        break;
      }
      case "danger": {
        this.barColor = "#e2001a";
        break;
      }
      case "info": {
        this.barColor = themeColor("--brand-600", "#2093c9");
        break;
      }
      case "success": {
        this.barColor = "#28a745";
        break;
      }
      default: {
        this.barColor = themeColor("--brand-ink", "#0c557d");
        break;
      }
    }
    // this.initChart();
  }
  @Input() chartName: string = "chart";
  @Input() chartLabel: string = "Label";
  @Input() valueLabel: string = "";
  @Input() height: number = 200;
  @Input() size: number = 60;
  @Input() value: number = 70;
  @Input() chartLabelSize: number = 24;
  @Input() valueLabelSize: number = 14;
  @Input() chartLabelWeight: number = 700;
  @Input() valueLabelWeight: number = 600;

  @Input() showLabel: boolean = true;
  @Input() showValue: boolean = true;

  public chartOptions: Partial<ApexOptions>;

  // Every value below is from the 2021 palette; the component shipped with
  // Bootstrap blue, Metronic green and three ambers that belong to no system
  // used here. A ring on white is a graphic, so each is dark enough to clear
  // 3:1 — #53bdee itself is 1.9:1 and cannot draw a 6px arc.
  barColor = themeColor("--brand-ink", "#0c557d");
  chartValue = 0;

  constructor() {}
  ngAfterViewChecked(): void {
    // this.initChart();
  }
  ngAfterViewInit(): void {
    // this.initChart();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.initChart();
    }
  }

  initChart() {
    this.chartOptions = {
      series: [this.value],
      chart: {
        height: this.height,
        type: "radialBar",
        events: {
          dataPointSelection: () => false, // ป้องกัน event click
        },
        // toolbar: {
        //   show: false, // ปิด toolbar
        // },
        // events: {
        //   dataPointSelection: (event, chartContext, config) => {
        //     // do nothing
        //     event.preventDefault(); // ป้องกัน action
        //   },
        // },
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: `${this.size}%`,
            // background: this.barColor,
          },
          track: {
            // background: "#e7e7e7",
            // strokeWidth: "100%",
            // margin: 5,
          },
          dataLabels: {
            name: {
              show: this.showLabel,
              fontSize: `${this.chartLabelSize}px`,
              fontWeight: this.chartLabelWeight,
            },
            value: {
              show: this.showValue,
              formatter: (val: number) => this.getValueLabel(val),
              fontSize: `${this.valueLabelSize}px`,
              fontWeight: this.valueLabelWeight,
            },
          },
        },
      },

      stroke: {
        lineCap: "round", // ✅ ทำให้ปลายแท่งมน
      },
      fill: {
        colors: [this.barColor],
      },
      labels: [this.chartLabel],
    };
  }

  getValueLabel(val: number): string {
    return this.valueLabel.length ? this.valueLabel : val.toString();
  }
}
